module.exports = __webpack_public_path__ + "static/media/document_illustration.0d79ad99.png";